import { formatAddressInline } from "../../../../../../../../../_shared/_logic/countries"
import type { AddressRow } from "../_shared/_logic/address-table-contract"
import { buildContactTags, buildUnitBadges } from "./tagPresentation"

export const formatAddress = (property: Property | undefined) => {
  if (!property) return "Keine Liegenschaft hinterlegt"

  return formatAddressInline(property) || "Keine Liegenschaft hinterlegt"
}

export const formatDate = (value: string | null | undefined) => {
  if (!value) return "–"

  const parsed = new Date(value)

  if (Number.isNaN(parsed.getTime())) return "–"

  return parsed.toLocaleDateString("de-DE")
}

export const buildCustomerById = (items: Customer[]) =>
  Object.fromEntries(items.map((customer) => [customer.id, customer])) as Record<string, Customer>

export const buildLinksByPropertyId = (links: PropertyCustomer[]) =>
  links.reduce(
    (acc, link) => {
      const list = acc[link.property_id] ?? []
      list.push(link)
      acc[link.property_id] = list

      return acc
    },
    {} as Record<string, PropertyCustomer[]>,
  )

export const mergeCustomers = (existing: Customer[] | unknown, incoming: Customer[] | unknown) => {
  const map = new Map<string, Customer>()
  const base = Array.isArray(existing) ? existing : []
  const next = Array.isArray(incoming) ? incoming : []
  base.forEach((entry) => entry?.id && map.set(entry.id, entry))
  next.forEach((entry) => entry?.id && map.set(entry.id, entry))

  return Array.from(map.values())
}

export const mergePropertyLinks = (
  existing: PropertyCustomer[] | unknown,
  incoming: PropertyCustomer[] | unknown,
) => {
  const map = new Map<string, PropertyCustomer>()
  const base = Array.isArray(existing) ? existing : []
  const next = Array.isArray(incoming) ? incoming : []
  base.forEach((entry) => entry?.id && map.set(entry.id, entry))
  next.forEach((entry) => entry?.id && map.set(entry.id, entry))

  return Array.from(map.values())
}

export const mergeProperties = (existing: Property[] | unknown, incoming: Property[] | unknown) => {
  const map: Record<string, Property> = {}
  const base = Array.isArray(existing) ? existing : []
  const next = Array.isArray(incoming) ? incoming : []
  base.forEach((entry) => entry?.id && (map[entry.id] = entry))
  next.forEach((entry) => entry?.id && (map[entry.id] = entry))

  return Object.values(map)
}

const fallbackRowId = () => globalThis.crypto?.randomUUID?.() ?? Math.random().toString(16).slice(2)

export const buildAddressRow = (
  property: Property | undefined,
  links: PropertyCustomer[],
  customerById: Record<string, Customer>,
  contactPoints: ContactPoint[],
): AddressRow => {
  return {
    id: property?.id ?? links[0]?.id ?? fallbackRowId(),
    address: formatAddress(property),
    unitBadges: buildUnitBadges(property, links, customerById, contactPoints),
    contactTags: buildContactTags(property, links, customerById, contactPoints),
    createdLabel: formatDate(links[0]?.created_at ?? property?.created_at),
    property,
    links,
  }
}
